"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Flex = require("../../../Layout/Flex");

var _Constant = require("../../Constant");

var _Constant2 = require("../../../Constant");

var _SidebarLink = _interopRequireDefault(require("../Sidebar/SidebarLink"));

var _theme, _theme2;

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.2rem;\n  font-weight: 700;\n  text-decoration: none;\n  line-height: 7.2rem;\n  text-align: center;\n  color: ", ";\n  flex-basis: 100%;\n  outline: none;\n\n  /* Focus styles on on keyboard focus */\n  /* The hover media query can be used to hide the background-color on mobile once the component design is updated. */\n  &:hover,\n  &[data-focus-visible-added]:focus {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &[data-focus-visible-added]:focus {\n    outline: 4px solid ", ";\n    outline-offset: -4px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-top: solid 1px ", ";\n  display: flex;\n  justify-content: space-around;\n\n  @media print, screen and (min-width: ", "px) {\n    border-right: solid 1px ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mainColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant2.Themes.HOMEBRIDGE, _Constant2.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, "homepoint", _Constant2.Color.HOMEPOINT_BLUE), (0, _defineProperty2.default)(_theme, _Constant2.Themes.SYNERGY_ONE, _Constant2.Color.BLACK), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme, _Constant2.Themes.GUARANTEED_RATE, _Constant2.Color.GUARANTEED_RATE_ARROW_RED), _theme));
var stateColor = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant2.Themes.HOMEBRIDGE, _Constant2.Color.HOMEBRIDGE_BLUE_DARK), (0, _defineProperty2.default)(_theme2, "homepoint", _Constant2.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme2, _Constant2.Themes.SYNERGY_ONE, _Constant2.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme2, "caliber", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, "figure", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, "petersendean", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, "pella", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, _Constant2.Themes.GUARANTEED_RATE, _Constant.Color.FOCUS), _theme2));
var LinkItem = (0, _styledComponents.default)(_Flex.FlexItem)(_templateObject(), _Constant.Color.GREY_3, _Constant2.Width.SM, _Constant.Color.GREY_3);
var Link = (0, _styledComponents.default)(_SidebarLink.default)(_templateObject2(), function (_ref) {
  var $color = _ref.$color;
  return $color;
}, mainColor, _Constant.Color.WHITE, stateColor);

var ActionLink = function ActionLink(_ref2) {
  var label = _ref2.label,
      onClick = _ref2.onClick,
      isRouterLink = _ref2.isRouterLink,
      to = _ref2.to,
      color = _ref2.color,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["label", "onClick", "isRouterLink", "to", "color"]);
  return /*#__PURE__*/_react.default.createElement(LinkItem, (0, _extends2.default)({
    flexGrow: 1
  }, rest), /*#__PURE__*/_react.default.createElement(Link, {
    isRouterLink: isRouterLink,
    to: to,
    onClick: onClick,
    children: label,
    $color: color || mainColor
  }));
};

ActionLink.propTypes = {
  /** Color of the label */
  color: _propTypes.default.string,

  /** Content that goes in the <Link> or <a> */
  label: _propTypes.default.string.isRequired,

  /** renders Link so page will not refresh */
  isRouterLink: _propTypes.default.bool,

  /** Available for those products that utilize onClick to navigate */
  onClick: _propTypes.default.func,

  /** The URL for the link. For an HTML anchor, should be passed as a string, for a react router Link, can be a string, object or function that returns a string or an object */
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
};
ActionLink.defaultProps = {
  color: null,
  isRouterLink: false,
  onClick: null,
  to: null
};
var _default = ActionLink;
exports.default = _default;